import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";

@Component({
  selector: 'online-enrolment-step-four',
  templateUrl: './online-enrolment-step-four.pug',
})
export class OnlineEnrolmentStepFourComponent implements OnInit {

  constructor(
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/online-enrolment-step-four.ts